import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { PlayIcon } from 'lucide-react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
// Fix for marker icons in react-leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
});
export function MapView({
  locations,
  currentLocationIndex,
  onLocationSelect,
  center
}) {
  return <div className="h-full" data-id="element-92">
      <MapContainer center={center} zoom={17} style={{
      height: '100%',
      width: '100%'
    }} data-id="element-93">
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' data-id="element-94" />
        {locations.map((location, index) => <Marker key={location.id} position={location.coordinates} icon={index === currentLocationIndex ? new L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      }) : new L.Icon.Default()} data-id="element-95">
            <Popup data-id="element-96">
              <div className="p-2" data-id="element-97">
                <h3 className="font-medium text-base" data-id="element-98">{location.name}</h3>
                <button className="mt-2 flex items-center gap-1 bg-blue-500 text-white px-3 py-1.5 rounded-full text-sm" onClick={() => onLocationSelect(index)} data-id="element-99">
                  <PlayIcon className="h-4 w-4" data-id="element-100" />
                  <span data-id="element-101">Play</span>
                </button>
              </div>
            </Popup>
          </Marker>)}
      </MapContainer>
    </div>;
}